import React, { useState } from 'react';
import { Smartphone, Users, TrendingUp, BarChart3 } from 'lucide-react';

const FioriAdoption = ({ project }) => {
  const [analytics] = useState({
    total_users: 2450,
    fiori_users: 890,
    adoption_rate: 36,
    app_usage: [
      { app: 'My Inbox (Universal)', users: 456, usage_per_day: 1200, adoption: 'high' },
      { app: 'Purchase Requisition', users: 234, usage_per_day: 890, adoption: 'medium' },
      { app: 'Approve Purchase Orders', users: 89, usage_per_day: 340, adoption: 'medium' },
      { app: 'Manage Sales Orders', users: 123, usage_per_day: 560, adoption: 'low' }
    ],
    training_gaps: [
      { role: 'Purchasing Team', current_adoption: 45, target_adoption: 90, training_needed: 'Yes' },
      { role: 'Sales Team', current_adoption: 28, target_adoption: 85, training_needed: 'Yes' },
      { role: 'Finance Team', current_adoption: 67, target_adoption: 95, training_needed: 'Partial' }
    ]
  });

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-3xl font-bold mb-2">Fiori Adoption & Usage Analyzer</h2>
        <p className="text-gray-600">Track Fiori app adoption and identify training gaps</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-blue-500 rounded-xl p-6 text-white">
          <Users className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{analytics.total_users.toLocaleString()}</div>
          <div className="text-sm">Total Users</div>
        </div>
        <div className="bg-purple-500 rounded-xl p-6 text-white">
          <Smartphone className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{analytics.fiori_users}</div>
          <div className="text-sm">Fiori Users</div>
        </div>
        <div className="bg-green-500 rounded-xl p-6 text-white">
          <TrendingUp className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{analytics.adoption_rate}%</div>
          <div className="text-sm">Adoption Rate</div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">App Usage Analytics</h3>
        <div className="space-y-3">
          {analytics.app_usage.map((app, i) => (
            <div key={i} className="border-2 border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-semibold text-gray-900">{app.app}</h4>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                  app.adoption === 'high' ? 'bg-green-100 text-green-700' :
                  app.adoption === 'medium' ? 'bg-yellow-100 text-yellow-700' :
                  'bg-red-100 text-red-700'
                }`}>{app.adoption} adoption</span>
              </div>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-gray-500">Active Users</p>
                  <p className="font-semibold">{app.users}</p>
                </div>
                <div>
                  <p className="text-gray-500">Usage/Day</p>
                  <p className="font-semibold">{app.usage_per_day}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">Training Gaps</h3>
        <div className="space-y-3">
          {analytics.training_gaps.map((gap, i) => (
            <div key={i} className="border-2 border-yellow-200 bg-yellow-50 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-semibold">{gap.role}</h4>
                <span className="text-sm font-semibold text-gray-700">{gap.current_adoption}% → {gap.target_adoption}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
                <div className="bg-blue-600 h-3 rounded-full" style={{width: `${gap.current_adoption}%`}}></div>
              </div>
              <p className="text-sm text-orange-600">Training needed: {gap.training_needed}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FioriAdoption;